import { render, staticRenderFns } from "./FooterFormService.vue?vue&type=template&id=4fa18f2d&"
import script from "./FooterFormService.vue?vue&type=script&lang=js&"
export * from "./FooterFormService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports